'use strict';

const forEach = require('lodash/forEach');

var React = require('react'),
    { t } = require('services/i18nextWrapper'),
    PropTypes = React.PropTypes,
    ContextMenuEl = require('components/Commons/ContextMenuCustom/ContextMenuEl'),
    DateUtils = require('utils/DateUtils'),
    OrderStore = require('stores/OrderStore'),
    SessionStore = require('stores/SessionStore'),
    ContentUtils = require('utils/ContentUtils'),
    BrowserUtils = require('utils/BrowserUtils'),
    OrderUtils = require('utils/OrderUtils'),
    ChronologycAction = require('actions/ChronologycActionCreators'),
    NotificationEl = require('components/Notification/Notification'),
    moment = require('moment'),
    mui = require('material-ui'),
    { delay } = require('lodash/function'),
    TextField = mui.TextField,
    IconButton = mui.IconButton,
    ChronologycStore = require('stores/ChronologycStore'),
    NoteSchedule = require('pollers/NoteSchedule'),
    ChronologycServiceCache = require('services/ChronologycServiceCache'),
    UIStateStore = require('stores/UIStateStore'),
    Note,
    Chronologyc,
    ga = require('react-ga'),
    WIDTH_COMMENT_DASHBOARD = require('constants/AppConstants').WIDTH_COMMENT_DASHBOARD,
    WIDTH_COMMENT_BUTTON_DASHBOARD = require('constants/AppConstants').WIDTH_COMMENT_BUTTON_DASHBOARD,
    ROW_HIGHT = require('constants/AppConstants').ROW_HIGHT,
    categories = require('constants/AppConstants').Analytics.categories,
    labels = require('constants/AppConstants').Analytics.labels,
    actions = require('constants/AppConstants').Analytics.actions;


const AMOUNT_CHARACTER_TO_SHOW_TOOLTIP = 25;

const rowsSelectedState = {
    isPressedClick: false,
    startDatePressed: '',
    endDatePressed: ''
}

Note = React.createClass({displayName: "Note",

    propTypes: {
        day: PropTypes.string,
        to: PropTypes.object,
        from: PropTypes.object,
        typeBar: PropTypes.string,
        isFirstNote: PropTypes.bool,
        isDisabled: PropTypes.bool
    },

    /**
     * Save the current message for this day of brewing notes.
     * @private
     */
    _onBlurBrewingNote() {
        ChronologycStore.setIsWritingFalse();
        this.refs.menssage.getDOMNode().setAttribute('data-is-writing', 'false');
        const oldValue = this.refs.menssage.getDOMNode().getAttribute('data-value') || this.props.day.message || '';
        let newValue = this.refs.menssage.getValue(),
            note,
            noteRecover;

        note = {
            date: this.props.day.date,
            message: this.refs.menssage.getValue()
        };

        this._showHideOrUpdateTooltipNote(newValue,'brewing-bar');

        if (newValue && !oldValue) { // is new note operation
            note = ChronologycServiceCache.addBrewingNote(note); // assign temporaryId
            ChronologycStore.setIsNoteSavingTrue();
            NoteSchedule.addBrewingNote(note);

            ga.event({
                category: categories.NOTES,
                action: actions.NEW,
                label: labels.NOTES_BREWING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });

        } else if (!newValue && oldValue) { // is remove note operation
            noteRecover = ChronologycServiceCache.getBrewingNoteByDate(note.date);
            ChronologycStore.setIsNoteSavingTrue();
            ChronologycServiceCache.removeBrewingNote(noteRecover);
            NoteSchedule.removeBrewingNote(note);
            ga.event({
                category: categories.NOTES,
                action: actions.DELETE,
                label: labels.NOTES_BREWING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });

        } else if (newValue) { // is change note operation
            ChronologycStore.setIsNoteSavingTrue();
            ChronologycServiceCache.addBrewingNote(note);
            NoteSchedule.changeBrewingNote(note);
            ga.event({
                category: categories.NOTES,
                action: actions.CHANGE,
                label: labels.NOTES_BREWING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });
        }

        this.refs.menssage.getDOMNode().setAttribute('data-value', newValue);
    },

    _onFocusMessage() {
        ChronologycStore.setIsWritingTrue();
        this.refs.menssage.getDOMNode().setAttribute('data-is-writing', 'true');
    },

    _showHideOrUpdateTooltipNote(date,typeBar) {
        const newValue = typeBar === 'packaging-bar' ? ChronologycServiceCache.getPackagingNoteByDate(date) : ChronologycServiceCache.getBrewingNoteByDate(date);
        const tooltipValue = newValue && newValue.message && newValue.message.length > AMOUNT_CHARACTER_TO_SHOW_TOOLTIP ? newValue.message : undefined;
        this.refs.menssage.getDOMNode().setAttribute('data-value', newValue);
        const el = this.refs.menssage.getDOMNode();

        if (el._tippy) {
            //     // first you need to check if exist an instance
                const instance = el._tippy;
                if (tooltipValue) {
            //         // enter here means we are updating the tooltip text
                    instance.setProps({ 'content': tooltipValue });
                } else {
            //         // enter here means you remove it text or it's smaller than before
            //         // so we need to destroy the tooltip instance.
                    instance.destroy();
                }
            } else if (tooltipValue) {
            //     // enter here means there is not already instance created for
            //     // this element, so should only add a tooltip if text length is enough
                el.setAttribute('data-tippy-content', tooltipValue || '');
                tippy(el);
        }

    },

    /**
     * Save the current message for this day of packaging notes.
     * @private
     */
    _onBlurPackagingNote() {
        ChronologycStore.setIsWritingFalse();
        this.refs.menssage.getDOMNode().setAttribute('data-is-writing', 'false');
        const oldValue = this.refs.menssage.getDOMNode().getAttribute('data-value') || this.props.day.message || '';
        let newValue = this.refs.menssage.getValue(),
            note,
            noteRecover;

        this.refs.menssage.getDOMNode().setAttribute('data-value', newValue);

        this._showHideOrUpdateTooltipNote(newValue,'packaging-bar');

        note = {
            date: this.props.day.date,
            message: this.refs.menssage.getValue()
        };

        if (newValue && !oldValue) { // is new note operation
            note = ChronologycServiceCache.addPackagingNote(note); // assign temporaryId
            ChronologycStore.setIsNoteSavingTrue();
            NoteSchedule.addPackagingNote(note);
            ga.event({
                category: categories.NOTES,
                action: actions.NEW,
                label: labels.NOTES_PACKAGING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });

        } else if (!newValue && oldValue) { // is remove note operation
            noteRecover = ChronologycServiceCache.getPackagingNoteByDate(note.date);
            ChronologycStore.setIsNoteSavingTrue();
            ChronologycServiceCache.removePackagingNote(noteRecover);
            NoteSchedule.removePackagingNote(note);
            ga.event({
                category: categories.NOTES,
                action: actions.DELETE,
                label: labels.NOTES_PACKAGING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });

        } else if (newValue) { // is change note operation
            ChronologycServiceCache.addPackagingNote(note);
            ChronologycStore.setIsNoteSavingTrue();
            NoteSchedule.changePackagingNote(note);
            ga.event({
                category: categories.NOTES,
                action: actions.CHANGE,
                label: labels.NOTES_PACKAGING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });
        }
    },

    componentWillReceiveProps(nextProps) {
        this._updateDate(nextProps.day);
    },

    componentDidMount() {
        this._updateDate(this.props.day);
        const text = this.refs.menssage.getValue();

        const el = this.refs.menssage.getDOMNode();
        tippy(el);

        // Initialize tooltip of large notes
        // if (text && text.length > AMOUNT_CHARACTER_TO_SHOW_TOOLTIP) {
        //     const el = this.refs.menssage.getDOMNode();
        //     el.setAttribute('data-tippy-content', this.refs.menssage.getValue() || '');
        //     tippy(el);
        // }
    },

    /**
     * Update text of the note.
     * @param messageDay
     * @private
     */
    _updateDate(messageDay) {
        var messageObject,
            textMessage;

        if (!this.refs.menssage) {
            return;
        }

        if (this.refs.menssage.getDOMNode().getAttribute('data-is-writing') === 'true') {
            // enter here means that the note are changing by the consumer
            return;
        }

        if (messageDay.message && this.refs.menssage.getValue() !== messageDay.message.message) {
            messageObject = messageDay.message;
            textMessage = messageObject.message ? messageObject.message : '';
            this.refs.menssage.setValue(textMessage);
        } else if (!messageDay.message && this.refs.menssage.getValue()) {
            // If enter here means that we remove a message, ant just need to clean textfield value.
            this.refs.menssage.setValue('');
        }
    },

    render() {
        var style,
            comentaryDayContent = SessionStore.isAdminUser() || SessionStore.isAbleToChangeNotes() ? 'comentary-day-content' : 'comentary-day-content is-disabled';
        if (this.props.typeBar === 'packaging-bar') {
            style = {
                display: UIStateStore.isPackagingNotesBarOpen() ? 'block' : 'none',
                position: 'relative',
                top: '35px'
            };
        } else {
            style = {
                display: UIStateStore.isBrewingNotesBarOpen() ? 'block' : 'none',
                position: 'relative',
                top: '35px'
            };
        }

        if (this.props.isFirstNote) {
            comentaryDayContent += ' is-first-note';
            comentaryDayContent += ' ' + this.props.typeBar;
        }
        return (
            React.createElement("div", {"data-date": this.props.day.date}, 
                React.createElement("div", {style: style, className: comentaryDayContent, "data-date": this.props.day.date}, 
                    React.createElement(TextField, {
                        ref: "menssage", 
                        className: "comment-day", 
                        fullWidth: true, 
                        style: { height: ROW_HIGHT + 'px'}, 
                        underlineDisabledStyle: { color: 'black', borderBottom: 'solid 1px #e0e0e0;;', zIndex: '1'}, 
                        disabled: this.props.isDisabled, 
                        onMouseMove: (evt) => {this._showHideOrUpdateTooltipNote(evt.target.getAttribute('data-date'),this.props.typeBar)}, 
                        onBlur: this.props.typeBar === 'packaging-bar' ? this._onBlurPackagingNote : this._onBlurBrewingNote, 
                        onFocus: this._onFocusMessage, 
                        "data-old-value": "", 
                        "data-is-writing": "false", 
                        "data-date": this.props.day.date}
                    )
                )
            )
        );
    }
});

Chronologyc = React.createClass({displayName: "Chronologyc",

    propTypes: {
        day: PropTypes.object,
        typeBar: PropTypes.string,
        showForwardOrders: PropTypes.func,
        showBackwardOrders: PropTypes.func,
        shouldUpdate: PropTypes.bool
    },

    componentWillMount() {
        UIStateStore.addChangeListener(this._onChange);
        ChronologycStore.addChangeListener(this._onChange);
    },

    componentWillUnmount() {
        UIStateStore.removeChangeListener(this._onChange);
        ChronologycStore.removeChangeListener(this._onChange);
    },

    startingWatcherScroll: null,
    endingWatcherScroll: null,
    startingTimeout: null,
    endingTimeout: null,

    _onChange() {
        this.forceUpdate();
    },

    _onClick(evt, { date }) {
        const barEl = ContentUtils.getComponentByElement(evt.target, 'DIV');
        if (barEl.classList.contains('is-highlight') && this.props.onDoubleClick) {
            barEl.classList.remove('is-selected');
            this.props.onDoubleClick(date);
        }
        cleanClassNames(evt);
        barEl.classList.toggle('is-highlight');
    },

    shouldComponentUpdate(nextProps) {
        if (ChronologycStore.isSavingNote()) {
            return false;
        }

        return nextProps.shouldUpdate;
    },

    render() {
        var elements = [],
            currentDaysBar = ChronologycStore.getRangeOfDate(this.props.from, this.props.to, this.props.typeBar),
            styleInlineChronologycBar = {},
            styleInlineButtonMessageDay = {},
            iconButton = React.createElement("i", {className: "material-icons md-48 btn-icon-center"}, "note_add"),
            chronologicBarStyle = 'chronologyc-bar-button',
            isPackagingBar = this.props.typeBar === 'packaging-bar';

        chronologicBarStyle += SessionStore.isPaidVersion() ? '' : ' is-free-version';

        if (isPackagingBar) {
            styleInlineChronologycBar = { width: UIStateStore.isPackagingNotesBarOpen() ? WIDTH_COMMENT_DASHBOARD + '%' : 'inherit' };
            styleInlineButtonMessageDay = {
                position: 'fixed',
                zIndex: 2,
                height: ROW_HIGHT + 'px',
                marginButton: ROW_HIGHT + 'px',
                width: WIDTH_COMMENT_BUTTON_DASHBOARD + 'px !important'
            };
        } else {
            styleInlineChronologycBar = { width: UIStateStore.isBrewingNotesBarOpen() ? WIDTH_COMMENT_DASHBOARD + '%' : 'inherit' };
            styleInlineButtonMessageDay = {
                position: 'fixed',
                zIndex: 2,
                height: ROW_HIGHT + 'px',
                marginButton: ROW_HIGHT + 'px',
                width: WIDTH_COMMENT_BUTTON_DASHBOARD + 'px !important'
            };
        }
        if (currentDaysBar) {
            // Open notes button
            if (UIStateStore.isBrewingNotesBarOpen() && this.props.typeBar !== 'packaging-bar') {
                iconButton = React.createElement("i", {className: "material-icons md-48 btn-icon-center"}, "keyboard_arrow_left");
                chronologicBarStyle += ' is-open';
                elements.push(getChronologycBarEl(_dispatchOpenBrewNote, true, t('dashboard_brewing_notes'), 'note_add'));
            }

            if (UIStateStore.isPackagingNotesBarOpen() && isPackagingBar) {
                iconButton = React.createElement("i", {className: "material-icons md-48 btn-icon-center"}, "keyboard_arrow_right");
                chronologicBarStyle += ' is-open';
                elements.push(getChronologycBarEl(_dispatchOpenPackagingNote, false, t('dashboard_packaging_notes'), 'note_add'));
            }

            if (isPackagingBar) {
                chronologicBarStyle += ' is-packaging-bar';
            } else {
                chronologicBarStyle += ' is-brewing-bar';
            }

            elements.push(
                React.createElement(IconButton, {
                    tooltipPosition: isPackagingBar ? 'bottom-left' : 'bottom-right', 
                    onClick: isPackagingBar ? _dispatchOpenPackagingNote : _dispatchOpenBrewNote, 
                    onTouchTap: BrowserUtils.isIpad() ? (isPackagingBar ? _dispatchOpenPackagingNote : _dispatchOpenBrewNote) : () => { }, 
                    className: chronologicBarStyle, 
                    style: styleInlineButtonMessageDay, 
                    labelStyle: {
                        color: 'black'
                    }, 
                    tooltip: isPackagingBar ? t('dashboard_packaging_notes') : t('dashboard_brewing_notes')}, 
                    iconButton
                )
            );

            var styleRow = '',
                chronologycBar = this.props.typeBar + ' chronologyc-bar';

            if (isPackagingBar) {
                if (!UIStateStore.isPackagingNotesBarOpen()) {
                    chronologycBar += ' is-close';
                }
            } else {
                if (!UIStateStore.isBrewingNotesBarOpen()) {
                    chronologycBar += ' is-close';
                }
            }

            if (!SessionStore.isPaidVersion()) {
                chronologycBar += ' is-free-version';
            }

            currentDaysBar.forEach(function (day, index) {
                styleRow = 'chronologyc-row row';
                var isFirstNote = false;
                if (DateUtils.isSaturday(day.date)) {
                    styleRow += ' is-saturday';
                }

                if (DateUtils.isSunday(day.date)) {
                    styleRow += ' is-sunday';
                }

                if (+moment(DateUtils.toDate(day.date)).format('DD') === 1) {
                    styleRow += ' is-month-starting';
                }

                if (day.date === this.props.from && !isPackagingBar) {
                    styleRow += ' is-starting-range';
                }

                if (day.date === DateUtils.addDaysTextBasicFormat(this.props.to, -1) && !isPackagingBar) {
                    styleRow += ' is-ending-range';
                }

                if (+moment(DateUtils.toDate(day.date)).format('MM') % 2 === 0) {
                    styleRow += ' is-month-light';
                } else {
                    styleRow += ' is-month-dark';
                }

                if (DateUtils.isToDay(day.date)) {
                    styleRow += ' is-highlight ';
                }

                if (!isPackagingBar && DateUtils.isToDay(day.date)) {
                    styleRow += ' is-to-day';
                }

                if (DateUtils.isMondayTuesdayOrWednesday(day.date)) {
                    styleRow += ' is-dark-row';
                } else {
                    styleRow += ' is-white-row';
                }

                if (index === 0) {
                    styleRow += ' is-first-note';
                    isFirstNote = true;
                }

                elements.push(
                    _createRowChronologycBar(this.props.typeBar, styleRow, day, this._onClick, isFirstNote)
                );
            }.bind(this));
        }

        return (
            React.createElement("div", {style: styleInlineChronologycBar, className: chronologycBar}, 
                React.createElement("div", {
                    className: "chronologyc-bar-inner-content", 
                    onContextMenu: (evt) => {
                        if (evt.nativeEvent.button === 2) {
                            evt.preventDefault();

                            const orders = OrderStore.getOrders();
                            const filteredOrders = OrderUtils.getOrderByRange(
                                rowsSelectedState.startDatePressed,
                                rowsSelectedState.endDatePressed,
                                orders
                            );

                            const candidateProductToConfirm = OrderUtils.getCandidateProductToConfirm(
                                filteredOrders,
                                rowsSelectedState.startDatePressed,
                                rowsSelectedState.endDatePressed
                            );

                            ContextMenuEl.show(
                                evt.clientX,
                                evt.clientY,
                                `${rowsSelectedState.startDatePressed} / ${rowsSelectedState.endDatePressed}`,
                                `${t('dashboard_modal_general_from_date')} / ${t('dashboard_modal_general_to_date')}`,
                                [
                                    {
                                        icon: 'done_all',
                                        text: t('dashboard_menu_items_confirm_all_products'),
                                        onClick: () => {
                                            if (candidateProductToConfirm.length) {
                                                for (let order of filteredOrders) {
                                                    const wasConfirmedSomeProduct = OrderUtils.confirmAllProductsByOrder(
                                                        order,
                                                        rowsSelectedState.startDatePressed,
                                                        rowsSelectedState.endDatePressed
                                                    );
                                                    if (wasConfirmedSomeProduct) {
                                                        OrderStore.changeOrderLight(order);
                                                    }
                                                }
                                            } else {
                                                NotificationEl.show(t('dashboard_menu_items_notification_no_confirmed_product', 'info'));
                                            }
                                        }
                                    },
                                ]
                            )
                        }
                    }, 
                    onMouseDown: (evt) => {
                        if (evt.nativeEvent.button !== 2) {
                            cleanClassNamesSelected();
                            const rowEl = getRowParent(evt);
                            if (!rowEl) return;
                            rowEl.childNodes[1].classList.toggle('is-selected')
                            rowsSelectedState.isPressedClick = true;
                            rowsSelectedState.startDatePressed = rowEl.getAttribute('data-date');
                            rowsSelectedState.endDatePressed = rowEl.getAttribute('data-date');
                        }
                    }, 
                    onMouseMove: (evt) => {
                        if (rowsSelectedState.isPressedClick && evt.nativeEvent.button !== 2) {
                            const rowEl = getRowParent(evt);
                            if (!rowEl) return;

                            if (!rowEl.childNodes[1].classList.contains('is-selected')) {
                                rowEl.childNodes[1].classList.add('is-selected')
                            }

                            // THS IS NEEDED IF THE USER LEAVES THE CRONOLOGYC BAR TO CHECK IF NEED TO MARK MORE ROWS DOWN
                            if(DateUtils.isAfter(rowEl.getAttribute('data-date'), rowsSelectedState.endDatePressed)){
                                let sum = 1;
                                let next = DateUtils.addDays(rowsSelectedState.endDatePressed, sum);
                                let query = '[data-date="' + DateUtils.toDateText(next) +'"]';
                                let oldRowEl = document.querySelector(query);
                                while(DateUtils.isAfter(rowEl.getAttribute('data-date'),DateUtils.toDateText(next))){
                                    if (!oldRowEl.childNodes[1].classList.contains('is-selected')) {
                                        oldRowEl.childNodes[1].classList.add('is-selected')
                                    }
                                    sum++;
                                    next = DateUtils.addDays(rowsSelectedState.endDatePressed, sum);
                                    query = '[data-date="' + DateUtils.toDateText(next) +'"]';
                                    oldRowEl = document.querySelector(query);
                                }
                            }

                            // THS IS NEEDED IF THE USER LEAVES THE CRONOLOGYC BAR TO CHECK IF NEED TO MARK MORE ROWS UP
                            if(DateUtils.isBefore(rowEl.getAttribute('data-date'), rowsSelectedState.startDatePressed)){
                                let sum = -1;
                                let next = DateUtils.addDays(rowsSelectedState.startDatePressed, sum);
                                let query = '[data-date="' + DateUtils.toDateText(next) +'"]';
                                let nextRowEl = document.querySelector(query);
                                while(DateUtils.isBefore(rowEl.getAttribute('data-date'),DateUtils.toDateText(next))){
                                    if (!nextRowEl.childNodes[1].classList.contains('is-selected')) {
                                        nextRowEl.childNodes[1].classList.add('is-selected')
                                    }
                                    sum--;
                                    next = DateUtils.addDays(rowsSelectedState.startDatePressed, sum);
                                    query = '[data-date="' + DateUtils.toDateText(next) +'"]';
                                    nextRowEl = document.querySelector(query);
                                }
                            }

                            // CHECK IF SELECTED WILL REPLACE START OR END DATE
                            if (DateUtils.isBefore(rowEl.getAttribute('data-date'), rowsSelectedState.startDatePressed)) {
                                rowsSelectedState.startDatePressed = rowEl.getAttribute('data-date');
                            } else if (DateUtils.isAfter(rowEl.getAttribute('data-date'), rowsSelectedState.endDatePressed)) {
                                rowsSelectedState.endDatePressed = rowEl.getAttribute('data-date');
                            }
                        } 
                    }, 
                    onMouseUp: (evt) => {
                        if (evt.nativeEvent.button !== 2) {
                            rowsSelectedState.isPressedClick = false;
                        }
                    }
                }, 
                    elements
                )
            )
        );
    }
});



/**
 * Create each of day row with the Chronology left side bar.
 * @param styleRow
 * @param day
 * @param onClick
 * @returns {XML}
 * @private
 */
function _createRowChronologycBar(typeBar, styleRow, day, onClick, isFirstNote) {

    let className = 'chronologyc-row-data-date';

    if (!UIStateStore.isBrewingNotesBarOpen() && UIStateStore.isPackagingNotesBarOpen() && isFirstNote) {
        // enter here means that only are open packaging side notes
        className += ' is-packaging-bar-only-open';
    }

    const isDisabled = SessionStore.isAdminUser()
        ? false
        : SessionStore.isAbleToChangeNotes()
            ? false
            : true;

    return (
        React.createElement("div", {className: className, "data-date": day.date}, 
            React.createElement(Note, {isDisabled: isDisabled, typeBar: typeBar, day: day, isFirstNote: isFirstNote}), 

            React.createElement("div", {
                "data-month-name": DateUtils.toDisplayMonthText(day.date), 
                "data-date": day.date, 
                onClick: evt => onClick(evt, day), 
                className: 'chronologyc-row row ' + styleRow
            }, 
                React.createElement("span", {
                    className: "dateName pull-left", 
                    ref: day.time + '_TWO', 
                    "data-month-name": DateUtils.toDisplayMonthTextShort(day.date), 
                    key: day.time + '_TWO'}, day.dateName
                ), 
                React.createElement("span", {
                    className: "dateNumber pull-right", 
                    ref: day.time, 
                    "data-month-name": DateUtils.toDisplayMonthTextShort(day.date).toUpperCase(), 
                    key: day.time}, day.dateNumber

                )
            )
        )
    );
}

/**
 * Toggle the action of open and close Left SideBar of messages.
 * @private
 */
function _dispatchOpenBrewNote() {
    NotificationEl.showImmediately(t('notification_wait_notes_loading'), 'info', 5);
    delay(() => {
        if (UIStateStore.isBrewingNotesBarOpen()) {
            UIStateStore.closeBrowingNotesBar();
            ChronologycAction.closeDayNotes();
            ga.event({
                category: categories.NOTES,
                action: actions.NAVIGATE,
                label: labels.NOTES_BREWING_CLOSE + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });
        } else {
            UIStateStore.openBrowingNotesBar();
            ChronologycAction.openDayNotes();
            ga.event({
                category: categories.NOTES,
                action: actions.NAVIGATE,
                label: labels.NOTES_BREWING_OPEN + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });
        }
    }, 500);
}

function getChronologycBarEl(onClick, isBrewing, title, icon) {
    var chronologycButtonHeaderStyle = 'chronologyc-button-header text-center';
    chronologycButtonHeaderStyle += isBrewing ? ' is-brewing' : ' is-packaging';
    chronologycButtonHeaderStyle += SessionStore.isPaidVersion() ? '' : ' is-free-version';
    return (React.createElement("div", {onClick: onClick, 
        onTouchTap: BrowserUtils.isIpad() ? onClick : () => { }, 
        className: chronologycButtonHeaderStyle}, 
        React.createElement("span", {className: "chronologyc-button-header-icon"}, React.createElement("i", {
            className: "material-icons md-48"}, icon)), 
        React.createElement("span", {className: "chronologyc-button-header-title"}, title)
    )
    );
}

/**
 * Toggle the action of open and close right SideBar of messages.
 * @private
 */
function _dispatchOpenPackagingNote() {
    NotificationEl.showImmediately(t('notification_wait_notes_loading'), 'info', 5);
    delay(() => {
        if (UIStateStore.isPackagingNotesBarOpen()) {
            UIStateStore.closePackagingNotesBar();
            ChronologycAction.closeDayNotes();
            ga.event({
                category: categories.NOTES,
                action: actions.NAVIGATE,
                label: labels.NOTES_PACKAGING_CLOSE + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });
        } else {
            UIStateStore.openPackagingNotesBar();
            ChronologycAction.openDayNotes();
            ga.event({
                category: categories.NOTES,
                action: actions.NAVIGATE,
                label: labels.NOTES_PACKAGING_OPEN + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });
        }
    }, 500);
}

/**
 * Clean the last highlight of chronologyc bar.
 * @argument {Event} evt that will take from the target element.
 */
function cleanClassNames(evt) {
    if (evt && evt.target) {
        const barEl = ContentUtils.getComponentByClassName(evt.target, 'chronologyc-bar');
        Array.from(barEl.querySelectorAll('.is-highlight')).forEach(rowEl => {
            rowEl.classList.remove('is-highlight');
        })
    } else {
        Array.from(document.querySelectorAll('.is-highlight')).forEach(rowEl => {
            rowEl.classList.remove('is-highlight');
        })
    }
}

function cleanClassNamesSelected(evt) {
    if (evt && evt.target) {
        const barEl = ContentUtils.getComponentByClassName(evt.target, 'is-selected');
        Array.from(barEl.querySelectorAll('.is-selected')).forEach(rowEl => {
            rowEl.classList.remove('is-selected');
        })
    } else {
        Array.from(document.querySelectorAll('.is-selected')).forEach(rowEl => {
            rowEl.classList.remove('is-selected');
        })
    }
}

function getRowParent(evt) {
    let el = evt.target;

    while (el && !el.classList.contains('chronologyc-row-data-date')) {
        el = el.parentElement;
    }
    return el;
}

module.exports = Chronologyc;




/** WEBPACK FOOTER **
 ** ./src/components/Chronologyc/Chronologyc.jsx
 **/